import React, { useState } from 'react';

interface BlueskyConnectModalProps {
  isOpen: boolean;
  userId: string;
  accessToken?: string;
  onClose: () => void;
  onSuccess: () => void;
}

export const BlueskyConnectModal: React.FC<BlueskyConnectModalProps> = ({ isOpen, userId, accessToken, onClose, onSuccess }) => {
  const [handle, setHandle] = useState('');
  const [appPassword, setAppPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleSave = async () => {
    setLoading(true);
    setError(null);
    try {
      // Prefer relative path so CRA proxy handles local network/IP origins
      const response = await fetch(`/api/auth/bluesky`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}) },
        body: JSON.stringify({ userId, handle, appPassword })
      });
      if (!response.ok) {
        let serverMsg = '';
        try {
          const data = await response.json();
          const parts = [data?.error, data?.details].filter(Boolean);
          serverMsg = parts.join(' — ');
        } catch (_) {
          // ignore JSON parse errors
        }
        const summary = serverMsg || `HTTP ${response.status}`;
        setError(summary || 'Failed to connect to Bluesky');
        setLoading(false);
        return;
      }
      setLoading(false);
      onSuccess();
      onClose();
    } catch (e: any) {
      setError(e.message || 'Failed to connect to Bluesky');
      setLoading(false);
    }
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose}
      style={{ position: 'fixed', left: 0, right: 0, top: 0, bottom: 0, background: 'rgba(0,0,0,0.7)', zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 'var(--app-height, 100svh)', width: '100vw' }}
    >
      <div 
        className="modal" 
        onClick={(e) => e.stopPropagation()}
        style={{ background: '#222', color: '#fff', borderRadius: 12, padding: 32, minWidth: 320, maxWidth: 400, boxShadow: '0 4px 32px rgba(0,0,0,0.4)', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}
      >
        <h2>Connect to Bluesky</h2>
        <div style={{ marginBottom: 16 }}>
          <label>Handle<br/>
            <input type="text" value={handle} onChange={e => setHandle(e.target.value)} placeholder="your.bsky.social" style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #444', marginTop: 4 }} />
          </label>
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>App Password<br/>
            <input type="password" value={appPassword} onChange={e => setAppPassword(e.target.value)} placeholder="App password" style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #444', marginTop: 4 }} />
          </label>
        </div>
        {error && <div style={{ color: '#e0245e', marginBottom: 12 }}>{error}</div>}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
          <button onClick={onClose} style={{ padding: '8px 24px', borderRadius: 6, background: '#444', color: '#fff', border: 'none' }} disabled={loading}>Cancel</button>
          <button onClick={handleSave} style={{ padding: '8px 24px', borderRadius: 6, background: '#0070f3', color: '#fff', border: 'none', fontWeight: 600 }} disabled={loading}>{loading ? 'Connecting...' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
}; 
